export { Area } from "./area/Area";
export { AreaMap } from "./area_map/AreaMap";
export { AreaSelect } from "./area_select/AreaSelect";
export { Carrieservice } from "./area/Carrieservice";
export { Detail } from "./detail/Detail";
export { Top } from "./top/Top";
export { NotFound } from "./notFound/NotFound";



// WEBPACK FOOTER //
// ./pages/index.js